import React from 'react';
import {Helmet} from 'react-helmet';
import {Router} from '@reach/router';

import {PageNav} from 'ui-kit';

import {AllPlans, NewPlan, PlanDetail} from './components';

export function Plans() {
  return (
    <div>
      <Helmet title="Plans" />

      <h1>Plans</h1>

      <PageNav
        links={[
          {url: './', content: 'All plans'},
          {url: '/plans/new', content: 'New plan'},
        ]}
      />

      <Router>
        <AllPlans path="/" />
        <NewPlan path="/new" />
        <PlanDetail path="/:id" />
      </Router>
    </div>
  );
}
